class CategoryEnum {
  /**
   * 根节点
   */
  static Root = '00000000-0000-0000-0000-000000000000';
}

export default {
  CategoryEnum
}
